import axios from "axios";

export const fetchGoalsData =
  (
    token,
    filter,
    userId,
    searchKey,
    challenges = false,
    yearData = {},
    subFilterData = null
  ) =>
  async (dispatch) => {
    dispatch({ type: "FETCH_USER_OWN_GOAL_REQUEST" });
    const search = searchKey ? searchKey : "";

    const year = yearData?.year ? yearData.year : "";
    const month = yearData?.month ? yearData.month : "";

    let filter_sub = "";
    let filter_sub_c = "";
    if (subFilterData?.subFilter) {
      filter_sub = subFilterData.subFilter;
    }
    if (subFilterData?.childFilter) {
      filter_sub_c = subFilterData.childFilter;
    }
    try {
      let response;
      if (challenges) {
        response = await axios.get(
          `${process.env.REACT_APP_API_URL_USER}/getUserGoals/${userId}?filter=${filter}&search=${search}&challenges=true&year=${year}&month=${month}&filter_sub=${filter_sub}&filter_sub_c=${filter_sub_c}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        response = await axios.get(
          `${process.env.REACT_APP_API_URL_USER}/getUserGoals/${userId}?filter=${filter}&search=${search}&year=${year}&month=${month}&filter_sub=${filter_sub}&filter_sub_c=${filter_sub_c}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

      if (searchKey) {
        if (response?.data?.success) {
          dispatch({
            type: "FETCH_USER_OWN_GOAL_SEARCH_SUCCESS",
            payload: response.data,
          });
        } else {
          dispatch({
            type: "FETCH_USER_OWN_GOAL_SEARCH_FAILURE",
            payload: response.data.message,
          });
        }
      } else {
        if (response?.data?.success) {
          dispatch({
            type: "FETCH_USER_OWN_GOAL_SUCCESS",
            payload: response.data,
          });
        } else {
          dispatch({
            type: "FETCH_USER_OWN_GOAL_FAILURE",
            payload: response.data.message,
          });
        }
      }
    } catch (error) {
      dispatch({
        type: "FETCH_USER_OWN_GOAL_FAILURE",
        payload: error.message,
      });
    }
  };
